import { Database } from './database';
import { Server } from './server';
import { Service, ServiceResponse } from './service';

export class GamesService extends Service {
  protected session: string;
  protected leaderboardCache: any[];

  constructor() {
    super();
    this.session = null;
    this.leaderboardCache = [];
  }

  public async startGame(id:string, tournament:boolean): Promise<ServiceResponse> {
    let response = await this.sendCommand('games', 'start-game', {id, tournament});

    if(response.status != 200)
      return {success: false, message: response.body.message};

    if(tournament) {
      let costToPlay = Database.getTournamentCost(id);
      Server.user.removeAssetsFromCache('coin', costToPlay);      
    }

    this.session = response.body.session;

    return {success: true};
  }

  public async finishGame(id:string, tournament:boolean, score:number) {
    let response = await this.sendCommand('games', 'finish-game', {session: this.session, id, score});

    if(response.status != 200)
      return {success: false, message: response.body.message};

    let coinsEarned = response.body.reward ? response.body.reward.coins : 0;
    let assetEarned = response.body.reward ? response.body.reward.asset : '';

    if(coinsEarned > 0)
      Server.user.addAssetsToCache('coin', coinsEarned);

    if(assetEarned != '')
      Server.user.addAssetsToCache(assetEarned, 1);

    let leaderboardId = id + (tournament ? '-tournament' : '');
    this.clearLeaderboardCache(leaderboardId);

    return {success: true, highScore: response.body.highScore, coins: coinsEarned, asset: assetEarned};
  }

  public async getSession(id:string) {
    let response = await this.sendCommand('games', 'get-session', {id});

    if(response.status != 200)
      return {success: false, message: response.body.message};

    return {success: true, session: response.body.session};
  }

  public async getLeaderboard(id:string) {
    let cacheEntry = null;
    for(let i = 0; i < this.leaderboardCache.length; i++) 
      if(this.leaderboardCache[i].game == id) 
        cacheEntry = this.leaderboardCache[i];

    if(cacheEntry) {
      let now = new Date();
      let elapsedMinutes = (now.getTime() - cacheEntry.date.getTime())/1000/60;
      if(elapsedMinutes < 5)
        return {success: true, leaderboard: cacheEntry.leaderboard};
    }

    let response = await this.sendCommand('public', 'get-leaderboard', {game: id});

    if(response.status != 200)
      return {success: false, message: response.body.message};

    let i = this.leaderboardCache.indexOf(cacheEntry);
    if(i != -1)
      this.leaderboardCache.splice(i, 1);

    this.leaderboardCache.push({
      game: id, 
      leaderboard: response.body.leaderboard, 
      date: new Date()
    });

    return {success: true, leaderboard: response.body.leaderboard};
  }

  public clearLeaderboardCache(id:string) {
    for(let i = 0; i < this.leaderboardCache.length; i++) {
      if(this.leaderboardCache[i].game == id) {
        this.leaderboardCache.splice(i, 1);
        return;
      }
    }
  }

  public async getScore(id:string) {
    let response = await this.sendCommand('games', 'get-score', {game: id});

    if(response.status != 200)
      return {success: false, message: response.body.message};

    return {success: true, score: response.body.score};
  }
}
